import {
  NumberInput as MantineNumberInput,
  type NumberInputProps as MantineNumberInputProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type NumberInputProps = CoreComponentProps<MantineNumberInputProps, 'input'>;

export function NumberInput({ testId, view = "all", ...rest }: NumberInputProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineNumberInput data-testid={testId} {...rest} />;
}
